import { CommonModule } from '@angular/common';
import {
  Component,
  input,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'dashboard-conversion-summary',
  imports: [CommonModule, CardModule, SkeletonModule],
  templateUrl: './conversion-summary.component.html',
})
export class ConversionSummaryComponent {
  icon = input.required<string>();
  alt = input.required<string>();
  content = input.required<string>();
  count = input.required<number>();
  isLoading = input.required<boolean>();

  successIcon = viewChild.required<TemplateRef<any>>('successIcon');
  failedIcon = viewChild.required<TemplateRef<any>>('failedIcon');
  reviewIcon = viewChild.required<TemplateRef<any>>('reviewIcon');

  getIconTemplate(icon: string): TemplateRef<any> {
    switch (icon) {
      case 'success':
        return this.successIcon() ;
      case 'failed':
        return this.failedIcon();
      case 'review':
        return this.reviewIcon();
      default:
        return this.failedIcon() ; 
    }
  }
}
